<template>
    <div class="chat-item" :class="{'chat-item_is-unread': room.unreadCount, 'is-selected': isSelected, 'is-pinned': isPinned}" :id="elementId">
        <div class="chat-item__container">
            <pinned class="pin" v-if="isPinned"></pinned>
            <div class="chat-item__avatar">
                <img :src="img" v-if="img" class="chat-item__image">
                <div class="chat-item__name" :style="{background: color}" v-else>
                    <span>{{ shortName }}</span>
                </div>
            </div>
            <div class="chat-item__info">
                <div class="chat-item-info__title">
                    <span>{{ title }}</span>
                </div>
                <div class="chat-item-info__text"  :class="{'with-unread': room.unreadCount}">
                    <span>{{ text }}</span>
                </div>
            </div>
            <div class="chat-item__date">
                <span>{{ date }}</span>
            </div>
            <div class="chat-item__unread" v-if="room.unreadCount && mode == 'icon'" :class="{muted: isMuted}">
                <span>{{ room.unreadCount }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {Room} from "../../models/Rooms/Room";
    import ChatTypes from "../../enums/ChatTypes";
    import Pinned from "../../../../assets/svg/pinned.svg";

    export default Vue.extend({
        name: "ChatItem",
        components: {Pinned},
        props: {
            room: {
                type: Room,
                required: true
            },
            isPinned: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            elementId() { //DOM id
                return this.room.userId ? `chat-item-${this.room.userId}` : `chat-item-${this.room.id}`;
            },
            user() {
                return this.$store.state.chat.profiles.list[this.room.userId] || null;
            },
            img() {
              return this.user && this.user.photoUrl(this.$store.state.session);
            },
            color() {
              return this.user ? this.user.color() : this.room.color();
            },
            shortName() {
                if (this.room.type == ChatTypes.direct && this.user) {
                    return this.user.initials();
                }
                return this.room.title ? this.room.title[0] : '';
            },
            title() {
                return this.user ? this.user.fullName() : this.room.title;
            },
            text() {
                return this.room ? this.room.message() : '';
            },
            date() {
                return this.room.date();
            },
            isMuted() {
                return !this.room.notifications;
            },
            mode() {
                return this.$store.state.chat.mode;
            },
            isSelected() {
                return this.$store.state.chat.room.instance && this.$store.state.chat.room.instance.id == this.room.id;
            }
        }
    });
</script>

<style>

</style>